const ID = 'input';

export default ID;
